"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTelemetrySender = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const TelemetryContext_1 = require("../telemetry/TelemetryContext");
const TelemetrySender_1 = require("../telemetry/TelemetrySender");
function useTelemetrySender(eventDefinition, valueHandling = 'remove', contextOverrides) {
    const baseContext = react_1.default.useContext(TelemetryContext_1.ReactTelemetryContext);
    const context = react_1.default.useRef(Object.assign(Object.assign({}, baseContext), contextOverrides));
    react_1.default.useEffect(() => {
        context.current = Object.assign(Object.assign({}, baseContext), contextOverrides);
    }, [baseContext, contextOverrides]);
    const sendEvent = react_1.default.useCallback((event) => {
        try {
            TelemetrySender_1.telemetrySender.sendEvent(Object.assign(Object.assign({}, eventDefinition), event), context.current, valueHandling);
        }
        catch (_) {
            return;
        }
    }, [eventDefinition, valueHandling]);
    return sendEvent;
}
exports.useTelemetrySender = useTelemetrySender;
//# sourceMappingURL=useTelemetrySender.js.map